<template>
    <order-summary-layout :product-store="productStore" :total-price="orderTotalPrice" :search-request="searchRequest">
        <div class="d-flex mb-4">
            <v-img
                :alt="offer.name"
                src="/home-bg-visa.jpg"
                lazy-src="/placeholder.png"
                height="150"
                tile
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                class="text-white align-end"
                @error="imgError = true"
            >
                <template v-slot:placeholder>
                    <v-row
                        v-show="!imgError && offer.mainImageUrl"
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                    >
                        <v-progress-circular indeterminate color="grey-lighten-5" />
                    </v-row>
                </template>
                <v-card-title>
                    <div class="d-flex flex-column" :title="offer.name">
                        <span class="text-subtitle-2">
                            {{ offer.name }}
                        </span>
                    </div>
                </v-card-title>
            </v-img>
        </div>
        <div>
            <supplier-name-label v-if="isTO1" :supplier-name="product.supplierName" />
            <div class="text-body-2" v-html="offer.shortDescription" />
        </div>
        <slot name="summary" />
        <v-divider class="mb-2" />
        <div>
            <div class="d-flex align-center font-weight-bold cursor-pointer mb-1" @click="offerInfo()">
                <v-icon size="small" start>mdi-information-outline</v-icon>
                <span>
                    {{ offer.name }}
                </span>
            </div>
            <div>
                <div v-if="offer.available" class="text-caption mt-1">
                    <v-icon :title="$t('available')" start size="small" class="text-success">
                        mdi-checkbox-marked-circle
                    </v-icon>
                    <span class="text-success" v-text="$t('available')" />
                </div>
                <div v-else class="text-caption mt-1">
                    <v-icon :title="$t('on_request')" start size="small" class="text-warning">mdi-alert-circle</v-icon>
                    <span class="text-warning" v-text="$t('on_request')" />
                </div>
            </div>
            <conditions-label
                v-if="offer"
                :offer-key="offer.offerKey"
                :price="offer.price"
                class="text-caption"
                @conditions="showConditionsInfo"
            />
            <div class="mt-1 font-weight-bold">
                <span>
                    {{ $filters.price(offer.price) }}
                </span>
                <commission-amount :commission="offer.price.commission" />
                <net-amount :search-request="searchRequest" :price="offer.price" />
            </div>
        </div>
    </order-summary-layout>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import OrderSummaryLayout from '@/components/booking/OrderSummaryLayout.vue'
    import ConditionsLabel from '~/components/snippets/ConditionsLabel.vue'
    import {EventBus, SHOW_VISA_CONDITIONS_INFO, SHOW_VISA_INFO_MODAL} from '@/utils/event-bus'
    import CommissionAmount from '@/components/snippets/CommissionAmount.vue'
    import NetAmount from '~src/components/snippets/NetAmount'
    import SupplierNameLabel from '@/components/hotels/snippets/SupplierNameLabel.vue'
    import SearchSummaryContent from '~/components/parts/SearchSummaryContent.vue'

    @Component({
        components: {
            SearchSummaryContent,
            OrderSummaryLayout,
            ConditionsLabel,
            CommissionAmount,
            NetAmount,
            SupplierNameLabel,
        },
    })
    export class VisaOrderSummary extends Vue {
        @Prop({required: true}) product
        @Prop({required: true}) offer
        @Prop({required: true}) searchRequest
        @Prop({default: true}) prebooked
        @Prop() prepareBookResponse

        imgError = false

        showConditionsInfo() {
            EventBus.$emit(SHOW_VISA_CONDITIONS_INFO, {searchRequest: this.searchRequest, offer: this.offer})
        }

        offerInfo() {
            EventBus.$emit(SHOW_VISA_INFO_MODAL, {offer: this.offer})
        }

        get productStore() {
            return insuranceStore
        }

        get orderTotalPrice() {
            return visaStore.orderTotalPrice(this.offer, this.prebooked, [], this.prepareBookResponse)
        }

        get isAgency() {
            return authStore.isAgency
        }

        get isTO1() {
            return authStore.isTO1
        }
    }

    export default VisaOrderSummary
</script>
